<div>
  <button class="close" (click)="onClose()">
    <i class="mt-cancel"></i>
  </button>
  <h1>Report Prepared</h1>
  <div class="message">Would you like to view the PDF?</div>
  <div class="buttons">
    <button class="button submit" [disabled]="isLoading" (click)="viewPDF()">View</button>
    <ion-spinner class='waiting' name='circles' *ngIf='isLoading'></ion-spinner>
    <button class="button cancel" (click)="onClose()">Cancel</button>
  </div>
</div>
